import React from "react";
import QurealStandardBubbleEditor from "../qureal_editor/QurealStandardBubbleEditor";
import styles from "./styles/QurealBlogs.module.css";
import { escape } from "lodash";
import { useMedia } from "react-use";

export default function QurealBlogs({ initialContent }) {
    const isMobile = useMedia("(max-width: 800px)");

    console.log("Blog Initial Content:", initialContent);
    const blogContainerStyle = {
        overflowY: "auto",
        maxWidth: isMobile ? "100%" : "800px",
        padding: isMobile ? "0" : "2.5rem 3rem",
        backgroundColor: "#fff",
        // border: "2px solid #00998e",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
        fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        paddingBottom: "100px"
    };

    return (
        <div>
            <QurealStandardBubbleEditor
                value={`<h1>${initialContent?.title}</h1><p></p>${initialContent?.body}`}
                wrapper_style={blogContainerStyle}
            />
        </div>
    );
}
